(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["caseFala"] = factory();
	else
		root["caseFala"] = factory();
})(self, () => {
return /******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be isolated against other entry modules.
(() => {
/*!*********************************!*\
  !*** ./assets/js-src/common.js ***!
  \*********************************/
// Módulo para gerenciar infinite scroll em páginas de arquivo
const InfiniteScroll = (function () {
  // Variáveis privadas do módulo
  let isLoading = false;
  let observer = null;
  let navElement = null;
  let activePageType = '';

  // Carrega a próxima página via AJAX
  const _loadNextPage = function (url) {
    if (isLoading) return;
    isLoading = true;

    // Exibe indicador de carregamento
    _showLoader();

    // Fetch do conteúdo da próxima página
    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error('Erro ao carregar a próxima página');
        }
        return response.text();
      })
      .then(html => {
        // Processa o HTML retornado
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Obtém os novos itens do loop
        const loopContent = document.querySelector('.loop-content');
        const newItems = doc.querySelectorAll('.loop-content-item');

        // Verifica se temos um container de loop e novos itens
        if (!loopContent || !newItems.length) {
          console.warn('Sem conteúdo para adicionar ou container não encontrado');
          return;
        }

        // Adiciona os novos itens ao DOM
        const addedItems = [];
        newItems.forEach(item => {
          const clonedItem = document.importNode(item, true);
          loopContent.appendChild(clonedItem);
          addedItems.push(clonedItem);
        });

        // Obtém a nova navegação
        const newNavigation = doc.querySelector('.navigation.posts-navigation');

        // Atualiza ou remove a navegação conforme a próxima página
        _updateNavigation(newNavigation);

        // Remove o indicador de carregamento
        _hideLoader();
      })
      .catch(error => {
        console.error('Erro no infinite scroll:', error);
        _hideLoader();
      })
      .finally(() => {
        isLoading = false;
      });
  };

  // Atualiza a navegação com os novos links
  const _updateNavigation = function (newNavigation) {
    if (!navElement) return;

    // Se não houver nova navegação, remove a atual
    if (!newNavigation) {
      navElement.remove();
      navElement = null;
      return;
    }

    // Obtém o novo link "Próxima"
    const newNavPrevious = newNavigation.querySelector('.nav-previous a');

    if (newNavPrevious) {
      // Atualiza o link atual
      const currentNavPrevious = navElement.querySelector('.nav-previous a');
      if (currentNavPrevious) {
        currentNavPrevious.setAttribute('href', newNavPrevious.getAttribute('href'));
        // Reinicializa o observer
        _setupIntersectionObserver();
      }
    } else {
      // Se não houver mais página, remove a navegação
      navElement.remove();
      navElement = null;
    }
  };

  // Exibe indicador de carregamento
  const _showLoader = function () {
    const loaderExisting = document.querySelector('.infinite-scroll-loader');

    if (loaderExisting) {
      loaderExisting.style.display = 'block';
      return;
    }

    const loader = document.createElement('div');
    loader.className = 'infinite-scroll-loader';
    loader.innerHTML = `
      <div class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
    `;

    // Adiciona estilos inline para o loader
    const style = document.createElement('style');
    style.textContent = `
      .infinite-scroll-loader {
        text-align: center;
        padding: 20px;
        clear: both;
      }
      .spinner {
        display: inline-block;
      }
      .spinner > div {
        width: 12px;
        height: 12px;
        background-color: #333;
        border-radius: 100%;
        display: inline-block;
        animation: sk-bouncedelay 1.4s infinite ease-in-out both;
        margin: 0 2px;
      }
      .spinner .bounce1 {
        animation-delay: -0.32s;
      }
      .spinner .bounce2 {
        animation-delay: -0.16s;
      }
      @keyframes sk-bouncedelay {
        0%, 80%, 100% { transform: scale(0); }
        40% { transform: scale(1.0); }
      }
    `;

    document.head.appendChild(style);

    // Adiciona o loader ao final da lista
    const loopContent = document.querySelector('.loop-content');
    if (loopContent) {
      loopContent.after(loader);
    }
  };

  // Esconde o indicador de carregamento
  const _hideLoader = function () {
    const loader = document.querySelector('.infinite-scroll-loader');
    if (loader) {
      loader.style.display = 'none';
    }
  };

  // Configura o Intersection Observer para a navegação
  const _setupIntersectionObserver = function () {
    if (!navElement) return;

    // Destrói o observer anterior se existir
    if (observer) {
      observer.disconnect();
      observer = null;
    }

    // Cria um novo observer
    observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !isLoading) {
            const nextPageLink = navElement.querySelector('.nav-previous a');
            if (nextPageLink) {
              _loadNextPage(nextPageLink.getAttribute('href'));
            }
          }
        });
      },
      {
        root: null,
        rootMargin: '100px',
        threshold: 0.1,
      }
    );

    // Observa o elemento de navegação
    observer.observe(navElement);
  };

  // Limpa todos os recursos e eventos ativos
  const _cleanup = function () {
    if (observer) {
      observer.disconnect();
      observer = null;
    }

    navElement = null;
    isLoading = false;
    activePageType = '';
  };

  // Inicializa o infinite scroll
  const _initialize = function () {
    // Limpa recursos anteriores
    _cleanup();

    // Encontra a navegação
    navElement = document.querySelector('.navigation.posts-navigation');

    if (!navElement) {
      console.debug('Navegação de posts não encontrada, infinite scroll não será inicializado');
      return;
    }

    // Identifica o tipo de página para animações específicas
    const mainContent = document.querySelector('main');
    if (mainContent && mainContent.dataset.animation) {
      activePageType = mainContent.dataset.animation;
      console.log(`Infinite scroll inicializado para página do tipo: ${activePageType}`);
    }

    // Configura o observer
    _setupIntersectionObserver();
  };

  // Interface pública do módulo
  return {
    init: function () {
      // Inicializa na carga da página
      _initialize();

      // Adiciona listener para transição de página
      document.addEventListener('pageTransitioned', function () {
        console.log('Página transitada, reinicializando infinite scroll');
        setTimeout(_initialize, 300); // Pequeno delay para garantir que o DOM esteja atualizado
      });
    },
  };
})();

// Módulo para debug visual
const ViewportDebug = (function () {
  // Variáveis privadas do módulo
  let debugBox = null;
  let isActive = false;

  // Verifica se a query string "vpdebug" existe
  const _checkQueryString = function () {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has('vpdebug');
  };

  // Cria o box de debug
  const _createDebugBox = function () {
    // Cria o elemento de debug
    debugBox = document.createElement('div');
    debugBox.id = 'viewport-debug';

    // Estilos para o box de debug
    const styles = `
      #viewport-debug {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100dvh;
        background-color: rgba(255, 255, 255, 0.95);
        color: #333;
        font-family: monospace;
        font-size: 14px;
        z-index: 99999;
        padding: 20px;
        box-sizing: border-box;
        overflow: auto;
        display: flex;
        flex-direction: column;
      }
      
      #viewport-debug h2 {
        margin: 0 0 15px;
        padding-bottom: 10px;
        border-bottom: 1px solid #333;
        font-size: 18px;
      }
      
      #viewport-debug .debug-section {
        margin-bottom: 20px;
        padding-bottom: 10px;
        border-bottom: 1px dashed #ccc;
      }
      
      #viewport-debug .debug-property {
        display: flex;
        justify-content: space-between;
        margin-bottom: 5px;
      }
      
      #viewport-debug .property-name {
        font-weight: bold;
        margin-right: 15px;
      }
      
      #viewport-debug .property-value {
        color: #0066cc;
      }
      
      #viewport-debug .close-button {
        position: absolute;
        top: 10px;
        right: 10px;
        background: #f44336;
        color: white;
        border: none;
        border-radius: 50%;
        width: 30px;
        height: 30px;
        font-size: 16px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      #viewport-debug details {
        margin-bottom: 10px;
      }
      
      #viewport-debug summary {
        background: #f1f1f1;
        border: none;
        border-radius: 4px;
        padding: 5px 10px;
        margin: 5px 0;
        width: 100%;
        text-align: left;
        cursor: pointer;
        outline: none;
      }
      
      #viewport-debug details[open] summary::before {
        content: '▼ ';
      }
      
      #viewport-debug details summary::before {
        content: '▶ ';
      }

      #viewport-debug .copy-button {
        background: #4CAF50;
        color: white;
        border: none;
        border-radius: 4px;
        padding: 5px 10px;
        margin: 10px 0;
        cursor: pointer;
        align-self: flex-start;
      }
    `;

    // Adiciona os estilos
    const styleElement = document.createElement('style');
    styleElement.textContent = styles;
    document.head.appendChild(styleElement);

    // Adiciona o conteúdo inicial
    _updateDebugContent();

    // Adiciona o box ao documento
    document.body.appendChild(debugBox);

    // Adiciona eventos para o botão de fechar
    const closeButton = document.createElement('button');
    closeButton.className = 'close-button';
    closeButton.innerHTML = '&times;';
    closeButton.addEventListener('click', _hideDebugBox);
    debugBox.appendChild(closeButton);

    // Adiciona botão para copiar informações
    const copyButton = document.createElement('button');
    copyButton.className = 'copy-button';
    copyButton.textContent = 'Copiar Todas Informações';
    copyButton.addEventListener('click', _copyDebugInfo);
    debugBox.appendChild(copyButton);

    isActive = true;
  };

  // Armazena o estado de expansão das seções
  const sectionStates = {};

  // Atualiza o conteúdo do box de debug
  const _updateDebugContent = function () {
    if (!debugBox) return;

    // Salvar o estado das seções abertas antes de atualizar
    const currentSections = debugBox.querySelectorAll('details');
    currentSections.forEach(details => {
      const summary = details.querySelector('summary');
      if (summary) {
        const sectionTitle = summary.textContent;
        const isExpanded = details.hasAttribute('open');
        sectionStates[sectionTitle] = isExpanded;
      }
    });

    // Preservar botões
    const closeButton = debugBox.querySelector('.close-button');
    const copyButton = debugBox.querySelector('.copy-button');

    // Limpa o conteúdo anterior
    debugBox.innerHTML = '';

    // Readicionar botões
    if (closeButton) debugBox.appendChild(closeButton);
    if (copyButton) debugBox.appendChild(copyButton);

    // Título
    const title = document.createElement('h2');
    title.textContent = 'Informações de Debug do Viewport';
    debugBox.appendChild(title);

    // Seção de Informações do Dispositivo
    _createSection('Dispositivo e Navegador', [
      { name: 'User Agent', value: navigator.userAgent },
      { name: 'Plataforma', value: navigator.platform },
      { name: 'Vendor', value: navigator.vendor },
      { name: 'Cookies Habilitados', value: navigator.cookieEnabled ? 'Sim' : 'Não' },
      { name: 'Idioma', value: navigator.language },
      { name: 'Online', value: navigator.onLine ? 'Sim' : 'Não' },
      { name: 'Cores Disponíveis', value: window.screen.colorDepth + ' bits' },
    ]);

    // Seção de Informações da Tela
    _createSection('Tela e Viewport', [
      { name: 'Largura da Janela', value: window.innerWidth + 'px' },
      { name: 'Altura da Janela', value: window.innerHeight + 'px' },
      { name: 'Largura da Tela', value: window.screen.width + 'px' },
      { name: 'Altura da Tela', value: window.screen.height + 'px' },
      { name: 'Largura Disponível', value: window.screen.availWidth + 'px' },
      { name: 'Altura Disponível', value: window.screen.availHeight + 'px' },
      { name: 'Pixel Ratio', value: window.devicePixelRatio },
    ]);

    // Seção de Media Queries
    const mediaQueries = [
      { name: 'Preferência de Cor', query: '(prefers-color-scheme: dark)' },
      { name: 'Redução de Movimento', query: '(prefers-reduced-motion: reduce)' },
      { name: 'Dispositivo Móvel', query: '(max-width: 768px)' },
      { name: 'Tablet', query: '(min-width: 769px) and (max-width: 1024px)' },
      { name: 'Desktop', query: '(min-width: 1025px)' },
      { name: 'Touch', query: '(hover: none) and (pointer: coarse)' },
    ];

    const mediaValues = mediaQueries.map(item => {
      return {
        name: item.name,
        value: window.matchMedia(item.query).matches ? 'Sim' : 'Não',
      };
    });

    _createSection('Media Queries', mediaValues);

    // Seção de Performance
    if (window.performance) {
      _createSection('Performance', [
        {
          name: 'Navegação Iniciada',
          value: new Date(performance.timeOrigin).toLocaleTimeString(),
        },
        { name: 'Tempo desde Início', value: Math.round(performance.now()) + 'ms' },
        {
          name: 'Tipo de Navegação',
          value: performance.navigation
            ? ['Navegação Normal', 'Recarregamento', 'Voltar/Avançar', 'Outros'][
                performance.navigation.type
              ]
            : 'N/A',
        },
      ]);
    }

    // Seção de URL e Query String
    _createSection('URL e Query String', [
      { name: 'URL Completa', value: window.location.href },
      { name: 'Pathname', value: window.location.pathname },
      { name: 'Query String', value: window.location.search || 'Nenhuma' },
      { name: 'Hash', value: window.location.hash || 'Nenhum' },
    ]);

    // Seção de Classes do Body
    const bodyClasses = document.body.classList;
    const bodyClassesArray = Array.from(bodyClasses);
    _createSection('Classes do Body', [
      { name: 'Quantidade de Classes', value: bodyClassesArray.length },
      {
        name: 'Lista de Classes',
        value: bodyClassesArray.length ? bodyClassesArray.join(', ') : 'Nenhuma classe',
      },
    ]);

    // Restaurar o estado das seções que estavam abertas
    _restoreSectionStates();
  };

  // Cria uma seção no box de debug
  const _createSection = function (title, properties) {
    const section = document.createElement('div');
    section.className = 'debug-section';

    // Cria o elemento details
    const details = document.createElement('details');

    // Verifica se a seção já estava expandida anteriormente
    const wasExpanded = sectionStates[title] === true;
    if (wasExpanded) {
      details.setAttribute('open', '');
    }

    // Cria o elemento summary para o título
    const summary = document.createElement('summary');
    summary.textContent = title;
    details.appendChild(summary);

    // Container para o conteúdo
    const content = document.createElement('div');

    // Adiciona propriedades
    properties.forEach(prop => {
      const property = document.createElement('div');
      property.className = 'debug-property';

      const propName = document.createElement('span');
      propName.className = 'property-name';
      propName.textContent = prop.name + ':';

      const propValue = document.createElement('span');
      propValue.className = 'property-value';
      propValue.textContent = prop.value;

      property.appendChild(propName);
      property.appendChild(propValue);
      content.appendChild(property);
    });

    details.appendChild(content);
    section.appendChild(details);
    debugBox.appendChild(section);

    return section;
  };

  // Restaura o estado das seções que estavam expandidas
  const _restoreSectionStates = function () {
    // Readiciona os botões
    const closeButtons = document.querySelectorAll('.close-button, .copy-button');
    closeButtons.forEach(button => {
      if (button.parentNode !== debugBox) {
        debugBox.appendChild(button);
      }
    });

    // Permite que o DOM seja atualizado antes de expandir as seções
    setTimeout(() => {
      // Expande as seções que estavam abertas antes
      Object.keys(sectionStates).forEach(title => {
        if (sectionStates[title]) {
          const section = Array.from(document.querySelectorAll('.debug-section')).find(
            s => s.querySelector('summary') && s.querySelector('summary').textContent === title
          );

          if (section && section.querySelector('details')) {
            section.querySelector('details').setAttribute('open', '');
          }
        }
      });
    }, 50);
  };

  // Copia as informações de debug
  const _copyDebugInfo = function () {
    let debugText = 'INFORMAÇÕES DE DEBUG DO VIEWPORT\n\n';

    // Coleta informações das seções
    const sections = document.querySelectorAll('.debug-section');
    sections.forEach(section => {
      const summary = section.querySelector('summary');
      if (!summary) return;

      const sectionTitle = summary.textContent;
      debugText += sectionTitle.toUpperCase() + '\n';

      const properties = section.querySelectorAll('.debug-property');
      properties.forEach(property => {
        const name = property.querySelector('.property-name').textContent;
        const value = property.querySelector('.property-value').textContent;
        debugText += name + ' ' + value + '\n';
      });

      debugText += '\n';
    });

    // Copia para clipboard
    navigator.clipboard
      .writeText(debugText)
      .then(() => {
        alert('Informações copiadas para a área de transferência!');
      })
      .catch(err => {
        console.error('Não foi possível copiar as informações: ', err);
        alert('Erro ao copiar informações. Consulte o console para detalhes.');
      });
  };

  // Esconde o box de debug
  const _hideDebugBox = function () {
    if (debugBox && debugBox.parentNode) {
      debugBox.parentNode.removeChild(debugBox);
      debugBox = null;
    }

    isActive = false;
  };

  // Interface pública do módulo
  return {
    init: function () {
      if (_checkQueryString()) {
        _createDebugBox();
      }

      // Adiciona listener para mudanças na URL
      window.addEventListener('popstate', function () {
        if (_checkQueryString() && !isActive) {
          _createDebugBox();
        } else if (!_checkQueryString() && isActive) {
          _hideDebugBox();
        }
      });
    },

    // Método para mostrar ou esconder manualmente
    toggle: function () {
      if (isActive) {
        _hideDebugBox();
      } else {
        _createDebugBox();
      }
    },
  };
})();

// Inicialização dos módulos quando o DOM estiver pronto
document.addEventListener('DOMContentLoaded', function () {
  InfiniteScroll.init();
  ViewportDebug.init();
});

})();

// This entry needs to be wrapped in an IIFE because it needs to be isolated against other entry modules.
(() => {
/*!********************************************!*\
  !*** ./assets/js-src/horizontal-scroll.js ***!
  \********************************************/
/**
 * Módulo de Scroll Horizontal Nativo
 *
 * Este módulo intercepta eventos de roda do mouse (wheel) em elementos
 * com scroll horizontal, convertendo o scroll vertical em horizontal
 * mantendo a experiência mais nativa possível.
 */

const HorizontalScroll = (function () {
  // Variáveis privadas do módulo
  let scrollableElements = [];
  let isEnabled = false;

  /**
   * Manipulador de evento de roda do mouse
   * @param {WheelEvent} event - Evento de roda do mouse
   */
  const _handleWheelEvent = function (event) {
    // Se o elemento não tiver overflow horizontal, não faz nada
    const container = event.currentTarget;

    // Verifica se há overflow horizontal no elemento
    const hasHorizontalOverflow = container.scrollWidth > container.clientWidth;
    if (!hasHorizontalOverflow) return;

    // Verifica se já existe um scroll nativo vertical em andamento
    // Se o usuário estiver no meio de uma rolagem vertical, não interceptamos
    if (Math.abs(event.deltaX) > Math.abs(event.deltaY) * 1.5) return;

    // Cancela o comportamento padrão para evitar o scroll vertical
    event.preventDefault();

    // Fatores para ajustar a velocidade do scroll
    // Aqui podemos ajustar baseado em diferentes dispositivos ou preferências
    const scrollSpeed = 2; // Ajuste conforme necessário para suavidade

    // Aplica o scroll horizontal usando o método nativo scrollBy
    // que mantém a inércia e comportamento nativo em dispositivos diferentes
    container.scrollBy({
      left: event.deltaY * scrollSpeed,
      behavior: 'smooth', // comportamento suave para melhor experiência
    });
  };

  /**
   * Configura os listeners de eventos para os elementos scrolláveis
   */
  const _setupEventListeners = function () {
    // Verifica se já está habilitado para evitar duplicação
    if (isEnabled) return;

    // Encontra todos os elementos scrolláveis que correspondem ao seletor
    const castingWrappers = document.querySelectorAll('.home .casting-posts-wrapper');

    if (castingWrappers.length === 0) return;

    // Adiciona o event listener para cada elemento encontrado
    castingWrappers.forEach(wrapper => {
      // Armazena referência ao elemento e seu handler para remoção posterior
      const elementData = {
        element: wrapper,
        handler: _handleWheelEvent,
      };

      // Adiciona o manipulador de eventos
      wrapper.addEventListener('wheel', _handleWheelEvent, { passive: false });

      // Armazena para limpeza posterior
      scrollableElements.push(elementData);
    });

    isEnabled = true;
    console.log('HorizontalScroll: Inicializado com sucesso');
  };

  /**
   * Remove os listeners de eventos dos elementos scrolláveis
   */
  const _removeEventListeners = function () {
    if (!isEnabled) return;

    // Remove todos os event listeners
    scrollableElements.forEach(data => {
      data.element.removeEventListener('wheel', data.handler);
    });

    // Limpa o array
    scrollableElements = [];
    isEnabled = false;
    console.log('HorizontalScroll: Desativado');
  };

  /**
   * Inicializa o módulo quando o DOM estiver pronto
   */
  const _init = function () {
    _setupEventListeners();

    console.log('HorizontalScroll: Módulo inicializado');

    // Adiciona listener para possíveis mudanças dinâmicas no DOM
    // Isso é útil quando a página é carregada via AJAX ou manipulada dinamicamente
    document.addEventListener('pageTransitioned', function () {
      // Primeiro remove os listeners antigos para evitar duplicação
      _removeEventListeners();
      // Depois configura os novos
      _setupEventListeners();
    });
  };

  // Interface pública do módulo
  return {
    init: _init,
    enable: _setupEventListeners,
    disable: _removeEventListeners,
  };
})();

// Inicializa o módulo quando o DOM estiver pronto
document.addEventListener('DOMContentLoaded', function () {
  HorizontalScroll.init();
});

})();

// This entry needs to be wrapped in an IIFE because it needs to be isolated against other entry modules.
(() => {
/*!***********************************************!*\
  !*** ./assets/js-src/casting-title-resize.js ***!
  \***********************************************/
/**
 * Ajuste dinâmico do tamanho do título nas páginas single-casting
 *
 * Este módulo ajusta o tamanho da fonte do título do artista para garantir
 * que ele fique em uma única linha e caiba perfeitamente no contêiner
 */

(function () {
  // Função principal do módulo
  const init = () => {
    // Verifica se estamos em uma página single-casting e se a largura é maior que 768px
    if (!document.body.classList.contains('single-casting') || window.innerWidth <= 768) {
      return;
    }

    const titleElement = document.querySelector('.single-casting h1.entry-title');
    const headerElement = document.querySelector('.single-casting .entry-header');
    const maxContainerWidthRatio = 0.99;

    if (!titleElement || !headerElement) {
      return;
    }

    // Função para ajustar o tamanho da fonte
    const adjustFontSize = () => {
      // Resetar o tamanho da fonte para um valor padrão para evitar problemas de cálculo
      titleElement.style.fontSize = '';

      // Esperar um momento para garantir que o navegador aplicou o reset do tamanho da fonte
      setTimeout(() => {
        // Obter a largura atual do título e do contêiner pai
        const titleWidth = titleElement.offsetWidth;
        const containerWidth = headerElement.offsetWidth;

        // Obter o tamanho atual da fonte
        const currentFontSize = parseFloat(window.getComputedStyle(titleElement).fontSize);

        if (titleWidth < containerWidth * maxContainerWidthRatio) {
          // Se o título for menor que o ratio do contêiner, aumentar a fonte
          // até no máximo 120px ou até preencher o contêiner
          let newFontSize = currentFontSize;

          while (
            titleElement.offsetWidth < containerWidth * maxContainerWidthRatio &&
            newFontSize < 120
          ) {
            newFontSize += 1;
            titleElement.style.fontSize = `${newFontSize}px`;

            // Se chegou no tamanho máximo ou está quase preenchendo o contêiner, para o loop
            if (
              newFontSize >= 120 ||
              titleElement.offsetWidth >= containerWidth * maxContainerWidthRatio
            ) {
              break;
            }
          }
        } else if (titleWidth > containerWidth) {
          // Se o título for maior que o contêiner, reduzir a fonte até caber
          let newFontSize = currentFontSize;

          while (titleElement.offsetWidth > containerWidth && newFontSize > 16) {
            newFontSize -= 1;
            titleElement.style.fontSize = `${newFontSize}px`;

            // Se chegou no tamanho mínimo ou já está cabendo no contêiner, para o loop
            if (newFontSize <= 16 || titleElement.offsetWidth <= containerWidth) {
              break;
            }
          }
        }

        // Atualizar a variável CSS com a altura do título
        const titleHeight = titleElement.offsetHeight;
        document.documentElement.style.setProperty(
          '--single-casting-header-height',
          `${titleHeight}px`
        );

        // Tornar o título visível novamente após todos os ajustes
        titleElement.style.opacity = '1';
      }, 50); // Pequeno delay para garantir que o navegador processou as alterações anteriores
    };

    // Ajustar o tamanho somente quando as imagens e recursos estiverem carregados
    window.addEventListener('load', adjustFontSize);

    // Também ajustar quando o DOM estiver pronto (para garantir)
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        // Adicionar um pequeno atraso para garantir que tudo está renderizado
        setTimeout(adjustFontSize, 100);
      });
    } else {
      // Adicionar um pequeno atraso para garantir que tudo está renderizado
      setTimeout(adjustFontSize, 100);
    }

    // Ajusta o tamanho quando a janela for redimensionada
    let resizeTimeout;
    window.addEventListener('resize', () => {
      // Verificar novamente as condições no evento de resize
      if (!document.body.classList.contains('single-casting') || window.innerWidth <= 768) {
        return;
      }

      // Usar debounce para evitar múltiplas execuções durante o redimensionamento
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(adjustFontSize, 250);
    });
  };

  // Executar a inicialização quando o DOM estiver pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

})();

// This entry needs to be wrapped in an IIFE because it needs to be isolated against other entry modules.
(() => {
/*!*******************************************!*\
  !*** ./assets/js-src/custom-scrollbar.js ***!
  \*******************************************/
/**
 * Módulo de Scrollbar Personalizada
 *
 * Este módulo substitui a scrollbar nativa do navegador por uma scrollbar
 * personalizada, com controle total sobre a aparência e o comportamento.
 * Especialmente desenvolvido para o conteúdo de casting que possui altura fixa.
 */

const CustomScrollbar = (function () {
  // Variáveis privadas do módulo
  let targetElement = null;
  let scrollbarContainer = null;
  let scrollbarThumb = null;
  let isDragging = false;
  let startY = 0;
  let startScrollTop = 0;
  let thumbHeight = 200; // Altura fixa da thumb conforme especificado
  let observer = null;

  /**
   * Cria os estilos CSS para a scrollbar personalizada
   */
  const _createStyles = function () {
    const styleId = 'custom-scrollbar-styles';

    // Verifica se os estilos já existem para evitar duplicação
    if (document.getElementById(styleId)) {
      return;
    }

    const styles = `
      .custom-scrollbar-container {
        position: absolute;
        right: 0;
        top: 0;
        width: 8px;
        height: 100%;
        background-color: transparent;
        z-index: 10;
      }
      
      .custom-scrollbar-thumb {
        position: absolute;
        right: 0;
        width: 8px;
        height: 200px; /* Altura fixa conforme especificado */
        background-color: rgba(255, 255, 255, 0.5);
        cursor: pointer;
        transition: opacity 0.2s ease;
      }

      /* Esconde a scrollbar nativa */
      .custom-scrollbar-enabled {
        -ms-overflow-style: none; /* IE e Edge */
        scrollbar-width: none; /* Firefox */
        overflow-y: auto;
      }
      
      .custom-scrollbar-enabled::-webkit-scrollbar {
        display: none; /* Chrome, Safari e Opera */
      }

      /* Container do conteúdo principal */
      .custom-scrollbar-content {
        position: relative;
        overflow-y: auto;
      }
    `;

    const styleElement = document.createElement('style');
    styleElement.id = styleId;
    styleElement.textContent = styles;
    document.head.appendChild(styleElement);
  };

  /**
   * Verifica se o elemento alvo existe e se precisa de scrollbar
   * @returns {boolean}
   */
  const _canApplyScrollbar = function () {
    targetElement = document.querySelector('.cf-custom-scroll');
    return targetElement !== null && targetElement.scrollHeight > targetElement.clientHeight;
  };

  /**
   * Cria os elementos HTML para a scrollbar personalizada
   */
  const _createScrollbarElements = function () {
    // Configura o elemento alvo
    targetElement.classList.add('custom-scrollbar-enabled');

    // Cria o container da scrollbar
    scrollbarContainer = document.createElement('div');
    scrollbarContainer.className = 'custom-scrollbar-container';

    // Cria o thumb da scrollbar
    scrollbarThumb = document.createElement('div');
    scrollbarThumb.className = 'custom-scrollbar-thumb';

    // Adiciona o thumb ao container
    scrollbarContainer.appendChild(scrollbarThumb);

    // Adiciona o container como irmão do elemento alvo
    targetElement.parentNode.style.position = 'relative';
    targetElement.parentNode.appendChild(scrollbarContainer);

    // Posiciona inicialmente o thumb
    _updateThumbPosition();
  };

  /**
   * Atualiza a posição do thumb baseado no scroll atual
   */
  const _updateThumbPosition = function () {
    if (!targetElement || !scrollbarThumb) return;

    const scrollPercentage =
      targetElement.scrollTop / (targetElement.scrollHeight - targetElement.clientHeight);
    const maxThumbTop = scrollbarContainer.clientHeight - thumbHeight;
    const thumbTop = scrollPercentage * maxThumbTop;

    scrollbarThumb.style.top = `${thumbTop}px`;
  };

  /**
   * Manipulador para o evento de mousedown no thumb da scrollbar
   * @param {MouseEvent} e
   */
  const _onThumbMouseDown = function (e) {
    e.preventDefault();

    isDragging = true;
    startY = e.clientY;
    startScrollTop = targetElement.scrollTop;

    // Adiciona eventos para acompanhar o movimento e o fim do arrasto
    document.addEventListener('mousemove', _onDocumentMouseMove);
    document.addEventListener('mouseup', _onDocumentMouseUp);

    // Adiciona classe para estilização durante o arrasto (opcional)
    scrollbarThumb.classList.add('dragging');
  };

  /**
   * Manipulador para o evento de mousemove no documento durante arrasto
   * @param {MouseEvent} e
   */
  const _onDocumentMouseMove = function (e) {
    if (!isDragging) return;

    const deltaY = e.clientY - startY;
    const scrollableHeight = targetElement.scrollHeight - targetElement.clientHeight;
    const maxThumbTop = scrollbarContainer.clientHeight - thumbHeight;

    // Calcula quanto o documento deve rolar baseado no movimento do mouse
    const scrollDelta = (deltaY / maxThumbTop) * scrollableHeight;
    targetElement.scrollTop = Math.max(0, Math.min(scrollableHeight, startScrollTop + scrollDelta));

    // Atualiza a posição visual do thumb
    _updateThumbPosition();
  };

  /**
   * Manipulador para o evento de mouseup no documento
   */
  const _onDocumentMouseUp = function () {
    isDragging = false;

    // Remove eventos de movimento e fim de arrasto
    document.removeEventListener('mousemove', _onDocumentMouseMove);
    document.removeEventListener('mouseup', _onDocumentMouseUp);

    // Remove classe de estilização de arrasto
    scrollbarThumb.classList.remove('dragging');
  };

  /**
   * Manipulador para o evento de scroll no elemento alvo
   */
  const _onTargetScroll = function () {
    _updateThumbPosition();
  };

  /**
   * Configura o MutationObserver para detectar mudanças no conteúdo
   */
  const _setupMutationObserver = function () {
    observer = new MutationObserver(function (mutations) {
      // Verifica se o conteúdo mudou de uma maneira que afete o scroll
      if (
        mutations.some(
          mutation =>
            mutation.type === 'childList' ||
            mutation.type === 'characterData' ||
            (mutation.type === 'attributes' && mutation.attributeName === 'style')
        )
      ) {
        // Verifica novamente se a scrollbar é necessária
        _updateScrollbarVisibility();
      }
    });

    // Observa mudanças no elemento alvo
    observer.observe(targetElement, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
    });
  };

  /**
   * Atualiza a visibilidade da scrollbar baseado no conteúdo atual
   */
  const _updateScrollbarVisibility = function () {
    if (!targetElement) return;

    const needsScrollbar = targetElement.scrollHeight > targetElement.clientHeight;

    if (needsScrollbar && scrollbarContainer) {
      scrollbarContainer.style.display = 'block';
      _updateThumbPosition();
    } else if (scrollbarContainer) {
      scrollbarContainer.style.display = 'none';
    }
  };

  /**
   * Inicializa o módulo
   */
  const _init = function () {
    if (!_canApplyScrollbar()) return;

    _createStyles();
    _createScrollbarElements();

    // Adiciona eventos de scroll e arrasto
    targetElement.addEventListener('scroll', _onTargetScroll);
    scrollbarThumb.addEventListener('mousedown', _onThumbMouseDown);

    // Configurar o observer para mudanças no conteúdo
    _setupMutationObserver();

    // Adicionar evento de resize para atualizar posição quando a janela for redimensionada
    window.addEventListener('resize', _updateScrollbarVisibility);

    console.log('CustomScrollbar: Módulo inicializado');
  };

  /**
   * Destrói o módulo e remove os elementos criados
   */
  const _destroy = function () {
    if (!targetElement) return;

    // Remove os event listeners
    targetElement.removeEventListener('scroll', _onTargetScroll);

    if (scrollbarThumb) {
      scrollbarThumb.removeEventListener('mousedown', _onThumbMouseDown);
    }

    window.removeEventListener('resize', _updateScrollbarVisibility);

    // Desconecta o observer
    if (observer) {
      observer.disconnect();
      observer = null;
    }

    // Remove a scrollbar container
    if (scrollbarContainer && scrollbarContainer.parentNode) {
      scrollbarContainer.parentNode.removeChild(scrollbarContainer);
    }

    // Remove a classe do elemento alvo
    if (targetElement) {
      targetElement.classList.remove('custom-scrollbar-enabled');
    }

    // Reset das variáveis
    targetElement = null;
    scrollbarContainer = null;
    scrollbarThumb = null;
    isDragging = false;
  };

  // Interface pública do módulo
  return {
    init: _init,
    destroy: _destroy,
  };
})();

// Inicializa o módulo quando o DOM estiver pronto
document.addEventListener('DOMContentLoaded', function () {
  CustomScrollbar.init();
});

})();

// This entry needs to be wrapped in an IIFE because it needs to be isolated against other entry modules.
(() => {
/*!*******************************************!*\
  !*** ./assets/js-src/casting-ellipsis.js ***!
  \*******************************************/
/**
 * Módulo para criar falsa "ellipsis" em elementos que transbordam
 *
 * Este módulo adiciona um elemento "..." (ellipsis) ao final de contêineres
 * .casting-areas quando seus elementos span internos transbordam o contêiner.
 */

const CastingEllipsis = (function () {
  // Variáveis privadas do módulo
  let resizeTimeout = null;
  let observerInstance = null;
  const RESIZE_DELAY = 200; // Debounce delay em ms

  /**
   * Verifica se deve inicializar o módulo (se estamos na página de arquivo casting)
   * @returns {boolean}
   */
  const _shouldInitialize = function () {
    return (
      document.body.classList.contains('post-type-archive-casting') ||
      document.body.classList.contains('tax-casting_area')
    );
  };

  /**
   * Verifica se um elemento span está transbordando seu contêiner pai
   * @param {HTMLElement} span - O elemento span a ser verificado
   * @param {HTMLElement} container - O elemento contêiner pai
   * @returns {boolean}
   */
  const _isOverflowing = function (span, container) {
    const spanRect = span.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();

    // Retorna true se o span estiver além da borda direita do contêiner
    return spanRect.right > containerRect.right;
  };

  /**
   * Encontra spans que transbordam e adiciona ellipsis
   * @param {HTMLElement} container - O contêiner .casting-areas a ser analisado
   */
  const _processContainer = function (container) {
    // Remove qualquer ellipsis existente antes de fazer nova análise
    const existingEllipsis = container.querySelector('.ellipsis');
    if (existingEllipsis) {
      existingEllipsis.remove();
    }

    // Obtém todos os spans dentro do contêiner
    const spans = container.querySelectorAll('span');
    let hasOverflow = false;

    // Se não houver spans, não há nada para fazer
    if (spans.length === 0) return;

    // Verifica se algum span está transbordando
    for (let i = 0; i < spans.length; i++) {
      if (_isOverflowing(spans[i], container)) {
        hasOverflow = true;
        break;
      }
    }

    // Se há transbordamento, adiciona o ellipsis
    if (hasOverflow) {
      const ellipsis = document.createElement('span');
      ellipsis.className = 'ellipsis';
      ellipsis.textContent = '...';
      container.appendChild(ellipsis);
    }
  };

  /**
   * Processa todos os contêineres .casting-areas na página
   */
  const _processAllContainers = function () {
    if (!_shouldInitialize()) return;

    const containers = document.querySelectorAll('.casting-areas');
    containers.forEach(_processContainer);
  };

  /**
   * Manipulador para o evento de redimensionamento da janela
   */
  const _handleResize = function () {
    // Implementa debounce para evitar múltiplas execuções durante redimensionamento
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(_processAllContainers, RESIZE_DELAY);
  };

  /**
   * Configura um MutationObserver para observar mudanças no DOM
   */
  const _setupObserver = function () {
    if (observerInstance) {
      observerInstance.disconnect();
    }

    // Observa a inserção de novos elementos .casting-areas
    observerInstance = new MutationObserver(function (mutations) {
      let shouldProcess = false;

      mutations.forEach(mutation => {
        if (mutation.type === 'childList' && mutation.addedNodes.length) {
          // Verifica se algum dos nós adicionados é ou contém um .casting-areas
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1) {
              // É um elemento
              if (node.classList && node.classList.contains('casting-areas')) {
                shouldProcess = true;
              } else if (node.querySelectorAll) {
                const areas = node.querySelectorAll('.casting-areas');
                if (areas.length > 0) {
                  shouldProcess = true;
                }
              }
            }
          });
        }
      });

      if (shouldProcess) {
        _processAllContainers();
      }
    });

    // Observa mudanças no corpo do documento
    observerInstance.observe(document.body, {
      childList: true,
      subtree: true,
    });
  };

  /**
   * Inicializa o módulo
   */
  const _init = function () {
    if (!_shouldInitialize()) return;

    // Processa contêineres existentes
    _processAllContainers();

    // Configura evento de redimensionamento
    window.addEventListener('resize', _handleResize);

    // Configura observador para alterações no DOM
    _setupObserver();

    console.log('CastingEllipsis: Módulo inicializado');
  };

  /**
   * Destrói o módulo e remove os event listeners
   */
  const _destroy = function () {
    window.removeEventListener('resize', _handleResize);

    if (observerInstance) {
      observerInstance.disconnect();
      observerInstance = null;
    }

    // Remove todos os elementos ellipsis
    const allEllipsis = document.querySelectorAll('.casting-areas .ellipsis');
    allEllipsis.forEach(el => el.remove());

    console.log('CastingEllipsis: Módulo destruído');
  };

  /**
   * Reinicia o módulo (útil para atualizações dinâmicas)
   */
  const _reinitialize = function () {
    _destroy();
    _init();
  };

  // Interface pública do módulo
  return {
    init: _init,
    destroy: _destroy,
    reinitialize: _reinitialize,
    processContainers: _processAllContainers, // Expõe função para processar contêineres sob demanda
  };
})();

// Inicializa o módulo quando o DOM estiver pronto
document.addEventListener('DOMContentLoaded', function () {
  CastingEllipsis.init();
});

})();

// This entry needs to be wrapped in an IIFE because it needs to be isolated against other entry modules.
(() => {
/*!**************************************!*\
  !*** ./assets/js-src/mobile-menu.js ***!
  \**************************************/
/**
 * Menu Mobile
 *
 * Este módulo gerencia o comportamento do menu mobile,
 * incluindo toggle, fechamento e acessibilidade.
 *
 * @package CaseFala
 * @since 1.0.0
 */

const MobileMenu = (function () {
  // Cache dos elementos DOM
  const DOM = {};

  // Estado inicial do menu
  let isMenuOpen = false;

  /**
   * Inicializa o cache dos elementos DOM
   */
  const cacheDOM = function () {
    DOM.body = document.querySelector('body');
    DOM.header = document.querySelector('.site-header');
    DOM.menuToggle = document.querySelector('.menu-toggle');
    DOM.mobileMenuContainer = document.querySelector('.mobile-menu-container');
    DOM.focusableElements = DOM.mobileMenuContainer
      ? DOM.mobileMenuContainer.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])')
      : [];
    DOM.firstFocusableElement = DOM.focusableElements[0];
    DOM.lastFocusableElement = DOM.focusableElements[DOM.focusableElements.length - 1];
  };

  /**
   * Configura os eventos de escuta
   */
  const bindEvents = function () {
    if (DOM.menuToggle) {
      DOM.menuToggle.addEventListener('click', toggleMenu);
    }

    // Fechar menu ao pressionar ESC
    document.addEventListener('keydown', handleKeyDown);

    // Fechar menu ao clicar fora dele
    document.addEventListener('click', handleClickOutside);

    // Tratamento de links que alteram foco
    if (DOM.mobileMenuContainer) {
      DOM.mobileMenuContainer.addEventListener('keydown', handleTabKey);
    }

    // Redimensionamento da janela
    window.addEventListener('resize', handleResize);
  };

  /**
   * Alterna o estado do menu mobile
   */
  const toggleMenu = function (event) {
    if (event) {
      event.preventDefault();
    }

    isMenuOpen = !isMenuOpen;

    // Atualiza o atributo aria-expanded
    if (DOM.menuToggle) {
      DOM.menuToggle.setAttribute('aria-expanded', isMenuOpen ? 'true' : 'false');
      DOM.menuToggle.setAttribute('aria-label', isMenuOpen ? 'Fechar menu' : 'Abrir menu');
      DOM.mobileMenuContainer.setAttribute('aria-hidden', isMenuOpen ? 'false' : 'true');
    }

    // Mostra/Oculta o menu
    if (DOM.mobileMenuContainer) {
      DOM.mobileMenuContainer.classList.toggle('is-active', isMenuOpen);
    }

    // Adiciona/Remove classe no body para prevenir rolagem
    if (DOM.body) {
      DOM.body.classList.toggle('menu-is-open', isMenuOpen);
    }
  };

  /**
   * Fecha o menu mobile
   */
  const closeMenu = function () {
    if (isMenuOpen) {
      isMenuOpen = false;

      if (DOM.menuToggle) {
        DOM.menuToggle.setAttribute('aria-expanded', 'false');
      }

      if (DOM.mobileMenuContainer) {
        DOM.mobileMenuContainer.classList.remove('is-active');
      }

      if (DOM.body) {
        DOM.body.classList.remove('menu-is-open');
      }
    }
  };

  /**
   * Trata eventos de teclas (Esc para fechar menu)
   *
   * @param {KeyboardEvent} event
   */
  const handleKeyDown = function (event) {
    // Fecha o menu ao pressionar Esc
    if (event.key === 'Escape' && isMenuOpen) {
      closeMenu();

      // Devolve o foco ao botão do menu
      if (DOM.menuToggle) {
        DOM.menuToggle.focus();
      }
    }
  };

  /**
   * Fecha o menu ao clicar fora dele
   *
   * @param {MouseEvent} event
   */
  const handleClickOutside = function (event) {
    if (
      isMenuOpen &&
      DOM.mobileMenuContainer &&
      !DOM.mobileMenuContainer.contains(event.target) &&
      !DOM.menuToggle.contains(event.target)
    ) {
      closeMenu();
    }
  };

  /**
   * Mantém o foco dentro do menu (trap focus) quando o menu está aberto
   *
   * @param {KeyboardEvent} event
   */
  const handleTabKey = function (event) {
    if (!isMenuOpen) return;

    // Se Tab e Shift são pressionados e o elemento com foco é o primeiro item focável
    if (
      event.key === 'Tab' &&
      event.shiftKey &&
      document.activeElement === DOM.firstFocusableElement
    ) {
      event.preventDefault();
      DOM.lastFocusableElement.focus();
    }

    // Se Tab é pressionado e o elemento com foco é o último item focável
    if (
      event.key === 'Tab' &&
      !event.shiftKey &&
      document.activeElement === DOM.lastFocusableElement
    ) {
      event.preventDefault();
      DOM.firstFocusableElement.focus();
    }
  };

  /**
   * Trata eventos de redimensionamento da janela
   */
  const handleResize = function () {
    // Se a largura da tela for maior que 1024px, fecha o menu mobile
    if (window.innerWidth > 1024 && isMenuOpen) {
      closeMenu();
    }
  };

  /**
   * Inicializa o módulo
   */
  const init = function () {
    cacheDOM();
    bindEvents();
  };

  // API pública
  return {
    init: init,
  };
})();

// Inicializa o módulo quando o DOM estiver carregado
document.addEventListener('DOMContentLoaded', function () {
  MobileMenu.init();
});

})();

// This entry needs to be wrapped in an IIFE because it needs to be isolated against other entry modules.
(() => {
/*!************************************************!*\
  !*** ./assets/js-src/viewport-size-manager.js ***!
  \************************************************/
/**
 * Universal Viewport Manager
 * Atualiza dinamicamente as variáveis:
 * --100vw, --100vh, --100dvw, --100dvh
 *
 * Detecta notch, toolbars dinâmicas e áreas inseguras (safe areas)
 * Compatível com Safari iOS (inclusive iOS 18 / “liquid glass”)
 *
 * @version 2.1
 */

const ViewportManager = (() => {
  let lastWidth = 0;
  let lastHeight = 0;
  let ticking = false;

  /**
   * Detecta se o dispositivo tem notch
   */
  const detectHasNotch = () => {
    if (!window.CSS || !window.CSS.supports) return false;
    if (window.CSS.supports('padding-top: env(safe-area-inset-top)')) {
      const div = document.createElement('div');
      div.style.cssText = `
        position: fixed;
        top: 0; left: 0;
        width: 0; height: 0;
        padding-top: env(safe-area-inset-top);
      `;
      document.body.appendChild(div);
      const style = window.getComputedStyle(div);
      const topInset = parseInt(style.paddingTop, 10) || 0;
      document.body.removeChild(div);
      return topInset > 20;
    }
    return false;
  };

  /**
   * Atualiza as variáveis CSS de viewport
   */
  const updateVars = () => {
    const width = window.innerWidth;
    const height = window.innerHeight;

    // Detecta insets reais
    let safeTop = 0,
      safeBottom = 0,
      safeLeft = 0,
      safeRight = 0;
    if (window.CSS && window.CSS.supports('padding-top: env(safe-area-inset-top)')) {
      const div = document.createElement('div');
      div.style.cssText = `
        position: fixed;
        top: 0; left: 0;
        width: 0; height: 0;
        padding-top: env(safe-area-inset-top);
        padding-bottom: env(safe-area-inset-bottom);
        padding-left: env(safe-area-inset-left);
        padding-right: env(safe-area-inset-right);
      `;
      document.body.appendChild(div);
      const style = getComputedStyle(div);
      safeTop = parseInt(style.paddingTop, 10) || 0;
      safeBottom = parseInt(style.paddingBottom, 10) || 0;
      safeLeft = parseInt(style.paddingLeft, 10) || 0;
      safeRight = parseInt(style.paddingRight, 10) || 0;
      document.body.removeChild(div);
    }

    // Calcula medidas úteis
    const usableWidth = width - safeLeft - safeRight;
    const usableHeight = height - safeTop - safeBottom;

    // Atualiza variáveis CSS
    const root = document.documentElement;
    root.style.setProperty('--100vw', `${window.outerWidth}px`);
    root.style.setProperty('--100vh', `${window.outerHeight}px`);
    root.style.setProperty('--100dvw', `${usableWidth}px`);
    root.style.setProperty('--100dvh', `${usableHeight}px`);

    // Debug opcional
    if (window.location.search.includes('vpdebug')) {
      console.table({
        Orientation: window.innerWidth > window.innerHeight ? 'Landscape' : 'Portrait',
        'window.innerWidth': window.innerWidth,
        'window.innerHeight': window.innerHeight,
        'window.outerWidth': window.outerWidth,
        'window.outerHeight': window.outerHeight,
        'usableWidth (--100dvw)': usableWidth,
        'usableHeight (--100dvh)': usableHeight,
        safeTop: safeTop,
        safeBottom: safeBottom,
        safeLeft: safeLeft,
        safeRight: safeRight,
        hasNotch: document.body.classList.contains('has-notch'),
      });
    }

    lastWidth = width;
    lastHeight = height;
  };

  /**
   * Recalcula apenas quando necessário
   */
  const requestUpdate = () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        updateVars();
        ticking = false;
      });
      ticking = true;
    }
  };

  /**
   * Inicia o módulo
   */
  const init = () => {
    updateVars();

    // Atualiza nas mudanças de viewport
    window.addEventListener('resize', requestUpdate);
    window.addEventListener('orientationchange', () => setTimeout(updateVars, 200));
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('load', updateVars);

    // Observa variações rápidas da altura (ex: barra flutuante iOS)
    let lastCheck = window.innerHeight;
    setInterval(() => {
      if (Math.abs(window.innerHeight - lastCheck) > 20) {
        lastCheck = window.innerHeight;
        updateVars();
      }
    }, 500);

    // Detecta notch
    if (detectHasNotch()) {
      document.body.classList.add('has-notch');
    }
  };

  return { init };
})();

document.addEventListener('DOMContentLoaded', () => {
  ViewportManager.init();
});

})();

// This entry needs to be wrapped in an IIFE because it needs to be isolated against other entry modules.
(() => {
/*!*****************************************!*\
  !*** ./assets/js-src/casting-filter.js ***!
  \*****************************************/
/**
 * Filtro de Elenco
 *
 * Este módulo gerencia a funcionalidade de abrir/fechar o filtro de elenco
 * por áreas na página de archive-casting, com suporte total à acessibilidade.
 *
 * @package CaseFala
 * @since 1.0.0
 */

const CastingFilter = (function () {
  // Cache dos elementos DOM
  const DOM = {};

  // Estado do filtro (aberto/fechado)
  let isFilterOpen = false;

  /**
   * Inicializa o cache dos elementos DOM
   */
  const cacheDOM = function () {
    DOM.filterButton = document.querySelector('.casting-filters--button');
    DOM.filterPanel = document.querySelector('.casting-areas-filter');
    DOM.chevronIcon = DOM.filterButton ? DOM.filterButton.querySelector('svg') : null;
  };

  /**
   * Alterna o estado do filtro (aberto/fechado)
   *
   * @param {Event} event - O evento de clique
   */
  const toggleFilter = function (event) {
    event.preventDefault();

    // Inverte o estado
    isFilterOpen = !isFilterOpen;

    // Atualiza a visibilidade do painel
    DOM.filterPanel.style.display = isFilterOpen ? 'block' : 'none';

    // Atualiza atributos de acessibilidade
    DOM.filterButton.setAttribute('aria-expanded', isFilterOpen ? 'true' : 'false');
    DOM.filterPanel.setAttribute('aria-hidden', isFilterOpen ? 'false' : 'true');

    // Rotaciona o ícone chevron
    if (DOM.chevronIcon) {
      DOM.chevronIcon.style.transform = isFilterOpen ? 'rotate(180deg)' : '';
    }
  };

  /**
   * Configura os event listeners
   */
  const bindEvents = function () {
    if (!DOM.filterButton) return;

    // Evento de clique no botão
    DOM.filterButton.addEventListener('click', toggleFilter);

    // Fecha o filtro ao clicar fora
    document.addEventListener('click', function (event) {
      if (
        isFilterOpen &&
        DOM.filterButton &&
        DOM.filterPanel &&
        !DOM.filterButton.contains(event.target) &&
        !DOM.filterPanel.contains(event.target)
      ) {
        // Simula um clique no botão para fechar
        toggleFilter(event);
      }
    });

    // Evento de tecla Escape para fechar o filtro
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isFilterOpen) {
        toggleFilter(event);
        // Retorna o foco ao botão
        DOM.filterButton.focus();
      }
    });
  };

  /**
   * Inicializa o módulo
   */
  const init = function () {
    // Verifica se estamos na página de arquivo de casting
    const castingArchive = document.querySelector('.archive-casting');
    if (!castingArchive) return;

    cacheDOM();
    bindEvents();
  };

  // Interface pública do módulo
  return {
    init: init,
  };
})();

// Inicializa o módulo quando o DOM estiver pronto
document.addEventListener('DOMContentLoaded', function () {
  CastingFilter.init();
});

})();

// This entry needs to be wrapped in an IIFE because it needs to be isolated against other entry modules.
(() => {
/*!**********************************************!*\
  !*** ./assets/js-src/about-parallax-logo.js ***!
  \**********************************************/
/**
 * About Page Logo Parallax
 *
 * Este módulo controla o posicionamento da imagem dentro do elemento .post-thumbnail
 * em relação ao .entry-content--logo na página About.
 * Quando o thumbnail fixo chega a 80px acima do logo, a imagem filha se desloca
 * para cima, criando o efeito de rolagem junto com a página.
 *
 * @package CaseFala
 * @since 1.0.0
 */

const AboutParallaxLogo = (function () {
  // Cache dos elementos DOM
  const DOM = {};

  // Estado e configurações
  const config = {
    offsetThreshold: 80, // Distância em pixels para começar o efeito
    isEnabled: false, // Estado ativo do módulo
    currentOffset: 0, // Deslocamento atual aplicado
  };

  /**
   * Verifica se estamos na página correta e com viewport adequado
   */
  const checkEligibility = function () {
    return document.body.classList.contains('page-template-page_about') && window.innerWidth > 768;
  };

  /**
   * Inicializa o cache dos elementos DOM e prepara para animação
   */
  const cacheDOM = function () {
    DOM.thumbnail = document.querySelector('.post-thumbnail');
    DOM.thumbnailImage = DOM.thumbnail ? DOM.thumbnail.querySelector('img') : null;
    DOM.logo = document.querySelector('.entry-content--logo');

    // Otimiza para animação
    if (DOM.thumbnailImage) {
      // Avisa o navegador que este elemento será animado
      DOM.thumbnailImage.style.willChange = 'transform';

      // Força o elemento a usar uma camada separada para renderização
      // isso melhora a performance em navegadores modernos
      DOM.thumbnailImage.style.backfaceVisibility = 'hidden';
    }
  };

  /**
   * Cache para otimizar cálculos de layout
   * Armazena valores que não precisam ser calculados a cada frame
   */
  const layoutCache = {
    lastUpdate: 0,
    throttleDelay: 5, // ms entre updates de layout para evitar reflow excessivo
    lastScrollY: 0,
    lastImageHeight: 0,
    lastLogoPosition: 0,
    lastThumbnailPosition: 0,
  };

  /**
   * Atualiza a posição da imagem com base no scroll
   * Otimizado para performance com cache e throttling
   */
  const updatePosition = function () {
    if (!config.isEnabled || !DOM.thumbnail || !DOM.thumbnailImage || !DOM.logo) return;

    // Throttling básico para evitar reflow excessivo
    const now = performance.now();
    const scrollY = window.scrollY;

    // Verifica se o scroll realmente mudou significativamente
    const scrollDelta = Math.abs(scrollY - layoutCache.lastScrollY);
    if (scrollDelta < 2 && now - layoutCache.lastUpdate < layoutCache.throttleDelay) {
      return;
    }

    // Atualiza o cache de scrollY
    layoutCache.lastScrollY = scrollY;
    layoutCache.lastUpdate = now;

    // Obtém as coordenadas dos elementos
    const thumbnailRect = DOM.thumbnail.getBoundingClientRect();
    const logoRect = DOM.logo.getBoundingClientRect();

    // Calcula a sobreposição
    const overlap = thumbnailRect.bottom - (logoRect.top + config.offsetThreshold);

    // Se há sobreposição, ajusta o transform na imagem filha
    if (overlap > 0) {
      // Calcula o novo valor para translateY
      const newOffset = overlap;

      // Aplica o transform na imagem filha apenas se a mudança for significativa (> 0.5px)
      if (Math.abs(config.currentOffset - newOffset) > 0.5) {
        DOM.thumbnailImage.style.transform = `translateY(-${newOffset}px)`;

        // Guarda o offset atual para referência
        config.currentOffset = newOffset;
      }
    } else {
      // Se não há sobreposição, restaura o transform original
      if (config.currentOffset > 0) {
        DOM.thumbnailImage.style.transform = '';
        config.currentOffset = 0;
      }
    }
  };

  /**
   * Reseta o estado do módulo
   */
  const reset = function () {
    if (DOM.thumbnailImage) {
      DOM.thumbnailImage.style.transform = '';
    }
    config.currentOffset = 0;
  };

  /**
   * Configura os event listeners
   */
  const bindEvents = function () {
    // Event listener para scroll
    window.addEventListener('scroll', updatePosition, { passive: true });

    // Event listener para redimensionamento
    window.addEventListener('resize', function () {
      const isNowEligible = checkEligibility();

      if (isNowEligible !== config.isEnabled) {
        config.isEnabled = isNowEligible;

        if (!config.isEnabled) {
          reset();
        } else {
          // Se tornou elegível, atualize imediatamente
          cacheDOM(); // Recache os elementos
          updatePosition();
        }
      }
    });

    // Listener para carregamento de imagens
    window.addEventListener('load', function () {
      // Recalcula após todas as imagens estarem carregadas
      updatePosition();
    });
  };

  /**
   * Inicializa o módulo
   */
  const init = function () {
    // Verifica se estamos na página correta e viewport adequado
    config.isEnabled = checkEligibility();

    if (config.isEnabled) {
      cacheDOM();

      if (DOM.thumbnail && DOM.thumbnailImage && DOM.logo) {
        bindEvents();
        // Executa a primeira atualização
        updatePosition();
      }
    }
  };

  // Interface pública do módulo
  return {
    init: init,
    // Expõe método para recálculo manual se necessário
    update: updatePosition,
  };
})();

// Inicializa o módulo quando o DOM estiver carregado
document.addEventListener('DOMContentLoaded', function () {
  AboutParallaxLogo.init();
});

})();

// This entry needs to be wrapped in an IIFE because it needs to be isolated against other entry modules.
(() => {
/*!*******************************************!*\
  !*** ./assets/js-src/casting-overflow.js ***!
  \*******************************************/
/**
 * Casting Overflow Detection
 *
 * Este módulo detecta quando as imagens dos itens de casting transbordam
 * seu contêiner e adiciona classes CSS para identificar o tipo de overflow.
 *
 * As classes são:
 * - img-ov-right: A imagem transborda pela direita
 * - img-ov-bottom: A imagem transborda por baixo
 *
 * @package CaseFala
 * @since 1.0.0
 */

const CastingOverflow = (function () {
  // Cache dos elementos DOM
  const DOM = {};

  // Estado e configurações
  const config = {
    breakpoint: 768, // Breakpoint para ativar/desativar
  };

  /**
   * Verifica se estamos na página correta e com viewport adequado
   */
  const checkEligibility = function () {
    return (
      (document.body.classList.contains('post-type-archive-casting') ||
        document.body.classList.contains('tax-casting_area')) &&
      window.innerWidth > config.breakpoint
    );
  };

  /**
   * Inicializa o cache dos elementos DOM
   */
  const cacheDOM = function () {
    DOM.container = document.querySelector('.casting-grid');
    DOM.items = DOM.container
      ? Array.from(DOM.container.querySelectorAll('.loop-casting-item'))
      : [];
    // Anexa listeners de hover sempre que recaching do DOM ocorrer
    addHoverListeners();
  };

  /**
   * Detecta e marca os overflows em cada item em relação à viewport
   * (mantida para possível uso externo via API .refresh)
   */
  const detectOverflows = function () {
    if (!DOM.items.length) return;

    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

    DOM.items.forEach(item => {
      const thumbnail = item.querySelector('.loop-casting-thumbnail');
      if (!thumbnail) return;

      const rect = thumbnail.getBoundingClientRect();

      const hasRightOverflow = rect.right > vw;
      const hasBottomOverflow = rect.bottom > vh;
      const hasTopOverflow = rect.top < 0;

      item.classList.toggle('img-ov-right', hasRightOverflow);
      item.classList.toggle('img-ov-bottom', hasBottomOverflow);
      item.classList.toggle('img-ov-top', hasTopOverflow);
    });
  };

  /**
   * Anexa listeners para simular :hover via JS
   * - mouseenter / mouseleave
   * - focusin / focusout (acessibilidade por teclado)
   */
  const addHoverListeners = function () {
    if (!DOM.items || !DOM.items.length) return;

    DOM.items.forEach(item => {
      // Evita vincular múltiplas vezes
      if (item.dataset.hoverBound === '1') return;

      // Função utilitária: calcula overflow da thumbnail do item em relação à viewport
      const computeAndApplyOverflow = function () {
        const thumbnail = item.querySelector('.loop-casting-thumbnail');
        if (!thumbnail) return;
        const rect = thumbnail.getBoundingClientRect();
        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

        const hasRightOverflow = rect.right > vw;
        const hasBottomOverflow = rect.bottom > vh;
        const hasTopOverflow = rect.top < 0;

        item.classList.toggle('img-ov-right', hasRightOverflow);
        item.classList.toggle('img-ov-bottom', hasBottomOverflow);
        item.classList.toggle('img-ov-top', hasTopOverflow);
      };

      const onEnter = function () {
        // Respeita elegibilidade (página + breakpoint)
        if (!checkEligibility()) return;
        // Primeiro verifica overflows em relação à viewport
        computeAndApplyOverflow();
        // Depois aplica a classe de hover
        item.classList.add('hover');
      };

      const onLeave = function () {
        // Remove hover e limpa classes de overflow
        item.classList.remove('hover');
        item.classList.remove('img-ov-right', 'img-ov-bottom', 'img-ov-top');
      };

      const onFocusIn = function () {
        if (!checkEligibility()) return;
        computeAndApplyOverflow();
        item.classList.add('hover');
      };

      const onFocusOut = function () {
        item.classList.remove('hover');
        item.classList.remove('img-ov-right', 'img-ov-bottom', 'img-ov-top');
      };

      item.addEventListener('mouseenter', onEnter);
      item.addEventListener('mouseleave', onLeave);

      // focusin/focusout cobrem elementos internos focáveis (links, buttons)
      item.addEventListener('focusin', onFocusIn);
      item.addEventListener('focusout', onFocusOut);

      // marca como ligado para evitar re-binding
      item.dataset.hoverBound = '1';
    });
  };

  // (Sem listeners globais: lógica roda apenas no hover/focus)

  /**
   * Inicializa o módulo
   */
  const init = function () {
    // Sempre cache o DOM
    cacheDOM();
  };

  // Interface pública do módulo
  return {
    init: init,
    refresh: detectOverflows,
  };
})();

// Inicializa o módulo quando o DOM estiver carregado
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(() => {
    CastingOverflow.init();
  }, 150);
});

})();

// This entry needs to be wrapped in an IIFE because it needs to be isolated against other entry modules.
(() => {
/*!*******************************!*\
  !*** ./assets/js-src/a11y.js ***!
  \*******************************/
// A11Y helpers — comportamento comum para sites preocupados com acessibilidade.
// - Detecta se o usuário está navegando via teclado (Tab) ou via mouse/pointer
//   e adiciona a classe `using-keyboard` ao <html> quando apropriado.
// - Garante que o link "skip to content" mova o foco para o alvo corretamente
//   (adiciona tabindex se necessário) para suportar navegadores que ignoram
//   elementos sem tabindex.
// - Pode ser estendido com outras helper functions do ally.js quando necessário.

(function () {
  'use strict';

  var doc = document.documentElement;
  var body = document.body;

  // Marca que JS está disponível
  doc.classList.add('has-js');

  // Modality detection: keyboard vs pointer
  var usingKeyboard = false;

  function handleFirstTab(e) {
    if (e.key === 'Tab' || e.keyCode === 9) {
      if (!usingKeyboard) {
        usingKeyboard = true;
        doc.classList.add('using-keyboard');
      }
    }
  }

  function handlePointerEvent() {
    if (usingKeyboard) {
      usingKeyboard = false;
      doc.classList.remove('using-keyboard');
    }
  }

  // Listeners: keydown for keyboard, and pointer/mouse/touch for pointer interactions
  window.addEventListener('keydown', handleFirstTab, true);
  window.addEventListener('mousedown', handlePointerEvent, true);
  window.addEventListener('pointerdown', handlePointerEvent, true);
  window.addEventListener('touchstart', handlePointerEvent, true);

  // Skip link handling: when a skip link is activated, ensure the target is focusable
  // and move focus programmatically. This improves support on browsers that do not
  // focus non-interactive elements by default when navigating via anchor.
  function handleSkipLinkClick(e) {
    var link = e.currentTarget;
    var href = link.getAttribute('href');
    if (!href || href.charAt(0) !== '#') {
      return;
    }

    var id = href.slice(1);
    var target = document.getElementById(id);
    if (!target) {
      return;
    }

    // If target is not focusable, temporarily add tabindex to allow focusing
    var needsTabIndex = false;
    var prevTabIndex = target.getAttribute('tabindex');
    if (!target.hasAttribute('tabindex') && !isFocusable(target)) {
      needsTabIndex = true;
      target.setAttribute('tabindex', '-1');
    }

    target.focus({ preventScroll: false });

    // If we added tabindex, remove it after blur to keep DOM clean
    if (needsTabIndex) {
      var removeTempTabindex = function () {
        if (prevTabIndex === null) {
          target.removeAttribute('tabindex');
        } else {
          target.setAttribute('tabindex', prevTabIndex);
        }
        target.removeEventListener('blur', removeTempTabindex);
      };
      target.addEventListener('blur', removeTempTabindex);
    }
  }

  // Basic focusable detection — covers common interactive elements
  function isFocusable(el) {
    if (!el) return false;
    var focusableSelectors = [
      'a[href]',
      'area[href]',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      'button:not([disabled])',
      'iframe',
      '[tabindex]',
      '[contenteditable]',
    ];
    try {
      if (
        el.matches &&
        focusableSelectors.some(function (s) {
          return el.matches(s);
        })
      ) {
        return true;
      }
    } catch (err) {
      // matches may throw on SVG in some browsers — ignore
    }
    return false;
  }

  // Wire up all skip links present on the page
  function initSkipLinks() {
    var skipLinks = document.querySelectorAll('a.skip-link');
    Array.prototype.forEach.call(skipLinks, function (link) {
      link.addEventListener('click', handleSkipLinkClick, false);
      // ensure skip links are visible to keyboard users (CSS handles visual)
      link.classList.add('skip-link-js');
    });
  }

  // Initialize on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initSkipLinks();
    });
  } else {
    initSkipLinks();
  }

  // Expose a small API for other modules if needed
  window.casefalaA11y = window.casefalaA11y || {};
  window.casefalaA11y.isUsingKeyboard = function () {
    return usingKeyboard;
  };
})();

})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=main.js.map